<app-sidebar-menu [toggleSub$]="toggleSub"></app-sidebar-menu>
<div class="main-container">
    <aside id="placid-aside" class="placid-aside bg-0f1d22">
        <div class="logo">
            <div routerLink="/home/1" *ngIf="userService.logo.length > 0">
                <img class="logo-img" style="max-height: 30px !important" [src]="userService.logo" alt="logo">
            </div>
        </div>

        <div class="d-table">
            <div class="d-table-cell">
                <ul class="navbar-nav">
                    <li *ngIf="styleService.appMenu.website" class="nav-item"><a class="nav-link" routerLink="/webpage"
                            routerLinkActive="active">{{ 'WEBSITE' | translate }}</a>
                    </li>
                    <li *ngIf="styleService.appMenu.events" class="nav-item"><a class="nav-link" routerLink="/events"
                            routerLinkActive="active">Events</a></li>
                    <li *ngIf="styleService.appMenu.sessions" class="nav-item"><a class="nav-link" routerLink="/sessions"
                            routerLinkActive="active">{{ 'SESSIONS' | translate }}</a>
                    </li>
                    <li *ngIf="styleService.appMenu.results" class="nav-item"><a class="nav-link" routerLink="/results"
                            routerLinkActive="active">{{ 'MAIN_TAB_RESULTS' | translate }}</a>
                    </li>
                    <li *ngIf="styleService.appMenu.lineup" class="nav-item"><a class="nav-link" routerLink="/lineup"
                            routerLinkActive="active">{{ 'LINEUP_SINGLE' | translate }}</a>
                    </li>
                    <li *ngIf="styleService.appMenu.schedule" class="nav-item"><a class="nav-link"
                            routerLink="/schedule" routerLinkActive="active">{{ 'SCHEDULE_SINGLE' | translate }}</a>
                    </li>
                    <li *ngIf="styleService.appMenu.news" class="nav-item"><a class="nav-link" routerLink="/news"
                            routerLinkActive="active">{{ 'MAIN_TAB_NEWS' | translate }}</a></li>
                    <!-- TODO: dynamic Gallery Tab -->
                    <li *ngIf="styleService.appMenu.gallery" class="nav-item"><a class="nav-link" routerLink="/gallery"
                            routerLinkActive="active">{{
                            'GALLERY_TAB' | translate }}</a></li>
                    <li *ngIf="styleService.appMenu.products" class="nav-item"><a class="nav-link" routerLink="/shop"
                            routerLinkActive="active">Shop</a></li>
                    <li *ngIf="styleService.appMenu.contact" class="nav-item"><a class="nav-link" routerLink="/contact"
                            routerLinkActive="active">{{ 'EVENT_DETAILS_TAB_CONTACT' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="aside-footer">
            <div class="user-btn-block" *ngIf="!styleService.editMode">
                <a routerLink="/user" *ngIf="auth.loggedIn$ | async">
                    <i class="flaticon-user mr-5"></i>
                </a>
                <a *ngIf="!(auth.loggedIn$ | async)" routerLink="/user" class="default-btn no-box-shadow">
                    Login
                </a>
                <a *ngIf="auth.loggedIn$ | async" (click)="onLogout()" routerLink="/login"
                    class="default-btn no-box-shadow">
                    Logout
                </a>
            </div>


            <ul class="social">
                <li *ngIf="privateProfile?.facebookLnk"><a href="{{ privateProfile?.facebookLnk }}" target="_blank"><i
                            class="ri-facebook-box-line"></i></a></li>
                <li *ngIf="privateProfile?.twitterLnk"><a href="{{ privateProfile?.twitterLnk }}" target="_blank"><i
                            class="ri-twitter-line"></i></a></li>
                <li *ngIf="privateProfile?.linkedinLn"><a href="{{ privateProfile?.linkedinLnk }}" target="_blank"><i
                            class="ri-linkedin-box-line"></i></a></li>
                <li *ngIf="privateProfile?.youtubeLnk "><a href="{{ privateProfile?.youtubeLnk }}" target="_blank"><i
                            class="ri-youtube-fill"></i></a></li>
                <li *ngIf="privateProfile?.instaLnk"><a href="{{ privateProfile?.instaLnk }}" target="_blank"><i
                            class="ri-instagram-line"></i></a></li>
            </ul>
        </div>

        <div class="line"></div>
    </aside>


    <div id="main-content" class="main-content">
        <div id="burgerMenu" class="responsive-burger-menu" (click)="onToggleBurgerMenu()">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>

        <section class="blog-details-area bg-0f1d22">
            <router-outlet></router-outlet>
        </section>
    </div>
</div>

<!-- </div> -->